import { IEnvironment } from './ienvironment';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment: IEnvironment = {
	production: true,
	restServices: [
		{
			name: 'metrics',
			get url() {
				return (
					window.location.protocol + '//' + window.location.hostname + '/rest/'
				);
			}
		}
	],
	authService: {
		name: 'auth',
		get url() {
			return (
				window.location.protocol + '//' + window.location.hostname + '/auth'
			);
		},
		clientId: 'HBApiClientID',
		clientPassword: 'arfuKT6MVZD59lM2tQNlVQ4dKVVx8+H1UCz8VGeQJUw='
	},
	realtimeServices: {
		get url() {
			return 'wss://' + window.location.hostname + '/mqtt/';
		},
		clientId: window.location.hostname + '-clientID'
	},
	showJSexception: false,
	checkFrontendEqualsBackend: true,
	firebaseConfig: {
		apiKey: 'AIzaSyC3mCGWgZMzbRiSg1mOLNmp3cbkF8hiHkc',
		authDomain: 'trackyourplant-test.firebaseapp.com',
		databaseURL: 'https://trackyourplant-test.firebaseio.com',
		projectId: 'trackyourplant-test',
		storageBucket: 'trackyourplant-test.appspot.com',
		messagingSenderId: '510051442658',
		appId: '1:510051442658:web:508553850104624426e3bb'
	}
};
